import React, { FC } from 'react';
import type { ViewStyle } from 'react-native';

import Skeleton from '@v2/elements/Skeleton';
import { WithColor } from '@styles/colors';
import { DEFAULT_CARD_SKELETON } from './constants';

// Agnostic card placeholder: one shimmer block covering the whole card area.
// Reuses the base Skeleton's flashing animation; knows nothing about what fills the card.
export interface CardSkeletonProps extends WithColor {
  width?: number | string;
  height?: number;
  borderRadius?: number;
  style?: ViewStyle;
}

const CardSkeleton: FC<CardSkeletonProps> = ({
  C,
  width = DEFAULT_CARD_SKELETON.width,
  height = DEFAULT_CARD_SKELETON.height,
  borderRadius = DEFAULT_CARD_SKELETON.borderRadius,
  style,
}) => <Skeleton C={C} width={width} height={height} borderRadius={borderRadius} style={style} />;

export default CardSkeleton;
